import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GruppoRami } from '../models/gruppo-rami';
import { ResourcefulService } from './resourcefulService';



@Injectable({
    providedIn: 'root'
})
export class GruppoRamiService extends ResourcefulService<GruppoRami>{
    constructor(private httpClient: HttpClient) {
        super(httpClient, GruppoRami);
    }
}
